const dataTestimonials = [
  {
    id: 1,
    text: "PipPlus Tech has completely changed the way I trade. The automation saves time, and I no longer worry about emotional decisions.",
    name: "Rohit",
    position: "Full-time Trader",
    img: "/assets/images/layouts/avt-01.png"
  },
  {
    id: 2,
    text: "I used to struggle managing trades manually. With PipPlus, I can run strategies on autopilot and still stay in control.",
    name: "Ankita Patel",
    position: "Finance Consultant",
    img: "/assets/images/layouts/avt-02.png"
  },
  {
    id: 3,
    text: "Best forex automation tool in the market. Simple dashboard, accurate results, and great customer support!",
    name: "Vivek Menon",
    position: "Investor",
    img: "/assets/images/layouts/avt-03.png"
  }
];

export default dataTestimonials;
